import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/route-ritage'

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })
  const resData = response?.data

  for (let i = 0; i < resData.data.paginated_result.length; i++) {
    resData.data.paginated_result[i].id = resData.data.paginated_result[i].ritage_id
    delete resData.data.paginated_result[i].ritage_id
  }
  return resData
}

export const show = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  const resData = response?.data

  resData.data.id = resData.data.ritage_id
  delete resData.data.ritage_id

  return resData
}

export const store = async (data) => {
  const payload = {
    ritage_name: data.name,
    departure_route_id: data.departureRouteId.toString(),
    return_route_id: data.returnRouteId?.toString(),
  }
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data: payload,
  })

  return response.data?.errors
    ? response?.data
    : {
        data: {
          id: response.data.data.ritage_id,
          name: data.name,
          departureRouteId: data.departureRouteId,
          returnRouteId: data.returnRouteId,
        },
      }
}

export const update = async (id, data) => {
  const payload = {
    ritage_name: data.name,
    departure_route_id: data.departureRouteId.toString(),
    return_route_id: data.returnRouteId?.toString(),
  }
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: payload,
  })

  return response.data?.errors
    ? response?.data
    : {
        data: {
          id: response.data.data.ritage_id,
          name: data.name,
          departureRouteId: data.departureRouteId,
          returnRouteId: data.returnRouteId,
        },
      }
}

export const updateStatus = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/change-status`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: baseEndpoint,
    data,
  })

  return response?.data
}
